import React from 'react';
import ImageIcon from '@mui/icons-material/Image';
import VideocamIcon from '@mui/icons-material/Videocam';
import AudiotrackIcon from '@mui/icons-material/Audiotrack';
import DescriptionIcon from '@mui/icons-material/Description';
import PermMediaOutlinedIcon from '@mui/icons-material/PermMediaOutlined';

export const getContentTypeIcon = (contentType) => {
    switch (contentType) {
        case 'image': return <ImageIcon />;
        case 'video': return <VideocamIcon />;
        case 'audio': return <AudiotrackIcon />;
        case 'text': return <DescriptionIcon />;
        default: return <PermMediaOutlinedIcon />;
    }
};